export default "__VITE_ASSET__d976af03__"